import _ from 'lodash';

export const selectUserProfileDetails = state => _.get(state, ['settings'], {});

